module.exports = __webpack_public_path__ + "img/gym.ab8dd60a.svg";